function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M298.9 6.5C125.6-21.9-21.9 125.6 6.5 298.9 26.8 422.4 132.2 509.6 257.4 509c12.3-.1 24.3-1 36-2.7 6.4-1 10.3-7.7 8.3-13.9L288 451.7c-1.6-4.7-6.1-7.5-11-7-6.9.7-13.9 1.1-21 1.1-106.4 0-192.7-88.2-189.7-195.3 2.8-98.9 85.3-181.3 184.1-184.1 107.1-3.1 195.3 83.3 195.3 189.7 0 7-.4 14.1-1.1 20.9-.5 4.9 2.4 9.5 7 11l40.8 13.6c6.2 2 12.9-1.8 13.8-8.3 1.7-11.7 2.7-23.7 2.7-36 .8-125.1-86.4-230.5-210-250.8",
  fillOpacity: ".6"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M377 263.2c-11.8-4-41.7-13.9-53.8-18.1-3.4-1.1-5.7-3.8-6.7-7.2-9.5-31.8-43.9-53.3-80.1-42.2-19.2 5.9-34.8 21.5-40.7 40.7-11.2 36.3 10.3 70.6 42.2 80.1 3.4 1.1 6.1 3.4 7.2 6.8l18.3 54.2c.6 2.3-.8 4.8-3.4 5.1h-1c-50.4 1.3-98.7-26.1-118.3-72.5C102.1 218 168.9 129.5 256 129.5c70.8 0 128.4 58.8 126.5 130.1v.4c-.2 1.9-1.5 3.9-3.6 3.6-.4 0-1.9-.4-1.9-.4",
  fillOpacity: ".8"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M499.9 346.4l-65.8 42.8 63 63c1.9 2.1 1.9 5.5 0 7.6l-37.3 37.3c-2.1 1.9-5.5 1.9-7.6 0l-63-63-42.8 65.8c-2.3 3.6-8 3-9.3-1.3l-77.8-232.5c-1.5-4.2 2.5-8.2 6.7-6.7l232.5 77.8c4.4 1.2 5 6.9 1.4 9.2"
})));